<template>
	<popup v-model="selfDisplay" title="新增" confirmBtnText="新增" @confirmClick="handleAddClick">
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>卡片名称</span>
				<el-select v-model="id" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in allCard" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>15天</span>
				<el-input v-model="num15" placeholder="请输入卡片数量"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="num15Tip"><i
						class="b_icon"></i>请输入卡片数量</template></div>

			<!-- <div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>30天</span>
				<el-input v-model="num30" placeholder="请输入卡片数量"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="num30Tip"><i
						class="b_icon"></i>请输入卡片数量</template></div>

			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>90天</span>
				<el-input v-model="num90" placeholder="请输入卡片数量"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="num90Tip"><i
						class="b_icon"></i>请输入卡片数量</template></div>

			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>180天</span>
				<el-input v-model="num180" placeholder="请输入卡片数量"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="num180Tip"><i
						class="b_icon"></i>请输入卡片数量</template></div>

			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>365天</span>
				<el-input v-model="num365" placeholder="请输入卡片数量"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="num365Tip"><i
						class="b_icon"></i>请输入卡片数量</template></div> -->
		</div>
	</popup>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import Api from '../../../../../../api/index.js';

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted() {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return {
				selfDisplay: false,
				loading: false,

				id: '认知发育卡',
				num15: '',
				num30: '',
				num90: '',
				num180: '',
				num365: '',
				num15Tip: false,
				num30Tip: false,
				num90Tip: false,
				num180Tip: false,
				num365Tip: false
			}
		},
		computed: {
			...mapState([
				'allCard'
			])
		},
		methods: {
			// 点击新增
			handleAddClick() {
				const that = this;
				if (!that.num15) {
					that.num15Tip = true;
					return false;
				} else {
					that.num15Tip = false;
				}
				// if (!that.num30) {
				// 	that.num30Tip = true;
				// 	return false;
				// } else {
				// 	that.num30Tip = false;
				// }
				// if (!that.num90) {
				// 	that.num90Tip = true;
				// 	return false;
				// } else {
				// 	that.num90Tip = false;
				// }
				// if (!that.num180) {
				// 	that.num180Tip = true;
				// 	return false;
				// } else {
				// 	that.num180Tip = false;
				// }
				// if (!that.num365) {
				// 	that.num365Tip = true;
				// 	return false;
				// } else {
				// 	that.num365Tip = false;
				// }
				that.loading = true;
				let requestData = {
					productId: that.id,
					days15Count: that.num15,
					days30Count: 0,
					days90Count: 0,
					days180Count: 0,
					days365Count: 0
					// days30Count: that.num30,
					// days90Count: that.num90,
					// days180Count: that.num180,
					// days365Count: that.num365
				};
				Api.addCardGenerate(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit('changeDisplay', newVal);
				if (newVal) {
					this.id = this.allCard[0].id;
				} else {
					this.loading = false;
					this.num15 = '';
					this.num30 = '';
					this.num90 = '';
					this.num180 = '';
					this.num365 = '';
					this.num15Tip = false;
					this.num30Tip = false;
					this.num90Tip = false;
					this.num180Tip = false;
					this.num365Tip = false;
				}
			}
		}
	}
</script>

<style>
</style>